var _excluded = ["fullWidth", "color", "label", "helperText", "helperTextPlacement", "edges", "variant", "disabled", "required", "options", "onChange", "showError", "errorMessage", "inputRef", "placeholder", "IconComponent", "size", "value", "name", "inputProps", "hideLabel", "allowEmpty", "weight", "onClear", "keepClearIconSpace", "checkboxProps", "onToggleAll", "toggleAllOptionLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Box from './Box';
import Checkbox from './Checkbox';
import FormControl from './FormControl';
import InputClearIcon from './InputClearIcon';
import useStyles from './Select/Select.styled';
import { StyledMultiSelectOption } from './MultiSelect.styled';
function MultiSelect(_ref) {
  var fullWidth = _ref.fullWidth,
    color = _ref.color,
    label = _ref.label,
    helperText = _ref.helperText,
    helperTextPlacement = _ref.helperTextPlacement,
    edges = _ref.edges,
    variant = _ref.variant,
    disabled = _ref.disabled,
    required = _ref.required,
    options = _ref.options,
    onChange = _ref.onChange,
    showError = _ref.showError,
    errorMessage = _ref.errorMessage,
    inputRef = _ref.inputRef,
    placeholder = _ref.placeholder,
    IconComponent = _ref.IconComponent,
    size = _ref.size,
    value = _ref.value,
    name = _ref.name,
    inputProps = _ref.inputProps,
    hideLabel = _ref.hideLabel,
    allowEmpty = _ref.allowEmpty,
    weight = _ref.weight,
    onClear = _ref.onClear,
    keepClearIconSpace = _ref.keepClearIconSpace,
    checkboxProps = _ref.checkboxProps,
    onToggleAll = _ref.onToggleAll,
    toggleAllOptionLabel = _ref.toggleAllOptionLabel,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = useStyles({
    size: size,
    edges: edges,
    variant: variant,
    required: required,
    native: false,
    placeholder: placeholder,
    value: value,
    color: color,
    weight: weight
  });
  var ref = useRef();
  var handleToggleAll = function handleToggleAll(e) {
    e.stopPropagation();
    var filtered = value.filter(function (val) {
      return !isNaN(parseFloat(val)) || !!val;
    });
    var checked = filtered.length === options.length;
    var vals = !checked ? options.map(function (option) {
      return option.value;
    }) : [];
    onToggleAll(vals);
    return false;
  };
  return /*#__PURE__*/React.createElement(Box, {
    width: fullWidth ? '100%' : 'auto',
    display: "flex",
    align: helperTextPlacement === 'below' ? 'center' : 'flex-end '
  }, /*#__PURE__*/React.createElement(FormControl, {
    color: color,
    fullWidth: fullWidth,
    label: label,
    name: name,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    disabled: disabled,
    required: required,
    showError: showError,
    errorMessage: errorMessage,
    edges: edges,
    hideLabel: hideLabel
  }, /*#__PURE__*/React.createElement(MuiSelect, _extends({
    name: name,
    className: classes.select,
    variant: variant,
    disabled: disabled,
    fullWidth: fullWidth,
    displayEmpty: !!placeholder || allowEmpty,
    error: !!(errorMessage && showError),
    inputProps: _extends({}, inputProps, {
      ref: inputRef
    }),
    inputRef: ref,
    MenuProps: _extends({
      style: {
        maxHeight: 500,
        maxWidth: 250
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      }
    }, !!rest.MenuProps && _extends({}, rest.MenuProps)),
    renderValue: function renderValue(selected) {
      var filtered = options.filter(function (option) {
        return selected.includes(option.value);
      });
      if (filtered.length === 0) {
        return /*#__PURE__*/React.createElement("span", {
          className: classes.placeholder
        }, placeholder);
      }
      return filtered.map(function (option) {
        return option.label;
      }).join(', ');
    },
    IconComponent: IconComponent === undefined ? KeyboardArrowDownIcon : IconComponent,
    value: value,
    onChange: onChange
  }, rest, {
    native: false,
    multiple: true
  }), function () {
    if (allowEmpty) {
      return /*#__PURE__*/React.createElement(MuiMenuItem, {
        selected: value.length === 0,
        className: classes.placeholder
      }, placeholder);
    }
    return null;
  }(), onToggleAll && /*#__PURE__*/React.createElement(StyledMultiSelectOption, {
    as: "li",
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    sx: {
      pointerEvents: 'auto'
    },
    display: "inline-flex"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    name: name + "[]",
    value: "all",
    label: toggleAllOptionLabel,
    checked: value.length === options.length,
    onChange: handleToggleAll,
    filledOnChecked: true
  }, checkboxProps)))), options && options.map(function (option) {
    return /*#__PURE__*/React.createElement(MuiMenuItem, {
      key: option.value,
      value: option.value,
      disabled: option.disabled,
      "aria-selected": option.focused,
      "data-focus": option.focused,
      disableRipple: true
    }, /*#__PURE__*/React.createElement(StyledMultiSelectOption, null, /*#__PURE__*/React.createElement(Checkbox, _extends({
      name: name + "[]",
      value: option.value,
      label: option.label,
      checked: value.includes(option.value),
      onChange: function onChange() {},
      filledOnChecked: true
    }, checkboxProps))));
  }))), (onClear && value.length > 0 || keepClearIconSpace) && /*#__PURE__*/React.createElement(Box, {
    marginBottom: "8px",
    minWidth: keepClearIconSpace ? '34px' : 'initial'
  }, onClear && value.length > 0 && /*#__PURE__*/React.createElement(InputClearIcon, {
    onClick: onClear
  })));
}
MultiSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Define color
   */
  color: PropTypes.oneOf(['default', 'inherit']),
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.string,
  /**
   * Placed the helper text above or below the input.
   */
  helperTextPlacement: PropTypes.oneOf(['above', 'below']),
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.any,
  /**
   * The label content.
   */
  label: PropTypes.string,
  /**
   * Make label visible only to screen readers
   */
  hideLabel: PropTypes.bool,
  /**
   * The label content.
   */
  name: PropTypes.string.isRequired,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,
  /**
   * The options for this field
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    disabled: PropTypes.bool,
    focused: PropTypes.bool
  })).isRequired,
  /**
   * The size to use.
   */
  size: PropTypes.oneOf(['medium', 'small', 'xsmall']),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  /**
   * @ignore
   */
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * @ignore
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  /**
   * Attributes applied to the input element. When native is true, the attributes are applied on the select element
   */
  inputProps: PropTypes.object,
  /**
   * Allow empty value
   */
  allowEmpty: PropTypes.bool,
  /**
    */
  keepClearIconSpace: PropTypes.bool,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   *
   */
  onClear: PropTypes.func,
  /**
   *
   */
  onToggleAll: PropTypes.func,
  /**
   *
   */
  toggleAllOptionLabel: PropTypes.string,
  /**
   *
   */
  weight: PropTypes.string,
  /**
   *
   */
  checkboxProps: PropTypes.shape({})
} : {};
MultiSelect.defaultProps = {
  disabled: false,
  color: 'default',
  edges: 'normal',
  fullWidth: true,
  helperText: '',
  helperTextPlacement: 'above',
  IconComponent: undefined,
  label: '',
  hideLabel: false,
  placeholder: '',
  required: false,
  size: 'medium',
  value: [],
  variant: 'outlined',
  showError: false,
  errorMessage: '',
  inputRef: null,
  inputProps: {},
  allowEmpty: false,
  keepClearIconSpace: false,
  onChange: function onChange() {
    return null;
  },
  onClear: undefined,
  onToggleAll: undefined,
  toggleAllOptionLabel: 'Select All',
  checkboxProps: {},
  weight: '500'
};
export default MultiSelect;